// extracted by mini-css-extract-plugin
export default {"buttons":"xkZvgk","alignRight":"fQDVdp"};